/** React Query keys for SOX dashboard data. */
export const SOX_CYCLES_QUERY_KEY = ['sox-cycles'];

export const processesQueryKey = (cycleId) => ['processes', cycleId];
export const cycleProcessesQueryKey = (cycleId) => ['cycle-processes', cycleId];

/** Grouped keys (same arrays as above) for shared imports / future nesting. */
export const soxQueryKeys = {
  cycles: {
    list: SOX_CYCLES_QUERY_KEY
  },
  processes: {
    list: processesQueryKey,
    byCycle: cycleProcessesQueryKey
  }
};
